import { useContext } from "react";

import { LoaderContext } from "../components/LoaderProvider";

const useLoader = () => {
  return useContext(LoaderContext);
};

export default useLoader;
